
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

interface TechniquesPaginationProps {
  currentPage: number;
  totalPages: number;
  onNextPage: () => void;
  onPrevPage: () => void;
}

export const TechniquesPagination: React.FC<TechniquesPaginationProps> = ({
  currentPage,
  totalPages,
  onNextPage,
  onPrevPage
}) => {
  const isMobile = useIsMobile();
  
  if (totalPages <= 1) return null;
  
  return (
    <div className="flex justify-center items-center gap-1 md:gap-2">
      <Button 
        variant="outline" 
        size={isMobile ? "sm" : "default"}
        onClick={onPrevPage} 
        disabled={currentPage === 1}
        className="text-xs md:text-sm py-1 md:py-2 px-2 md:px-3"
      >
        <ChevronLeft className="h-3 w-3 md:h-4 md:w-4 mr-1" />
        {!isMobile && "Previous"}
      </Button>
      
      <span className="text-xs md:text-sm mx-2">
        {currentPage} / {totalPages}
      </span>
      
      <Button 
        variant="outline" 
        size={isMobile ? "sm" : "default"}
        onClick={onNextPage} 
        disabled={currentPage === totalPages}
        className="text-xs md:text-sm py-1 md:py-2 px-2 md:px-3"
      >
        {!isMobile && "Next"}
        <ChevronRight className="h-3 w-3 md:h-4 md:w-4 ml-1" />
      </Button>
    </div>
  );
};
